module.exports = __webpack_public_path__ + "static/img/platform_advantages3.be15df3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/platform_advantages3.png
// module id = iZ41
// module chunks = 2